module.exports = __webpack_public_path__ + "static/1150397417.f05b980e.jpg";